
export default function AboutBanner() {
  return (
    <section className="py-16 bg-stone-50">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <p className="text-lg md:text-xl text-stone-700 leading-relaxed">
          <strong>Cosmetica Pro Shop Valencia</strong>, somos una empresa dedicada a la distribución de productos profesionales de manicura, pedicura y cosmética para centros estéticos y profesionales del sector con años de experiencia en el mercado.
        </p>
      </div>
    </section>
  );
}
